<template>
<el-dialog :title="viewFlag === 'view' ? '查看-定点申请接收数据' : !dataForm.id ? '新增' : '修改'" :append-to-body="true" :close-on-click-modal="false" width="60%" :visible.sync="viewData.visible">
    <!-- 定点申请类别 设变 寻源申请 样件 其他 与李亮坤确认-->
    <!-- 添加招标工作计划 -->
    <!-- QA：通知模板样例 -->
    <div>
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="0px" class="org-dialog-form">
            <el-tabs style="min-height: 65vh;">
                <el-tab-pane class="tab_style" :key="1" label="基础信息" >
                    <div class="des_box mb15">
                        <el-descriptions class="margin-top" :column="2" size="small" border>
                            <el-descriptions-item label="项目:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="projectManagerName" size="small">
                                    {{ projectName }}&nbsp;&nbsp;<el-button v-if="viewFlag !== 'view' && dataForm.technicalStatus === '0'" size="small" @click="selectProject()">
                                        选择项目
                                    </el-button>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="车型:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="carType" size="small">
                                    <span>{{dataForm.carType}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="定点申请编码:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="technicalCode" size="small">
                                    <span v-if="dataForm.technicalStatus === '2'"> <font color = "red">{{dataForm.technicalCode}}</font></span>
                                    <span v-else>{{dataForm.technicalCode}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="定点申请主题:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="technicalName" size="small">
                                    <el-input v-if="viewFlag !== 'view' && dataForm.technicalStatus === '0'" size="small" v-model="dataForm.technicalName" placeholder="定点申请主题" clearable>
                                    </el-input>
                                    <span v-else>{{dataForm.technicalName}}</span>
                                </el-form-item>
                            </el-descriptions-item>

                            <el-descriptions-item label="定点申请类型:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="technicalType">
                                    <span>{{getPlmTechnicalTypeValue(dataForm.technicalType)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="定点申请状态" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="technicalStatus">
                                     <span v-if="dataForm.technicalStatus === '2'"> <font color = "red">{{getPLMTechnicalStatusValue(dataForm.technicalStatus)}}</font></span>
                                     <span v-else>{{getPLMTechnicalStatusValue(dataForm.technicalStatus)}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <template v-if="dataForm.technicalType === '0'">

                                <el-descriptions-item label="寻源申请类型:" :label-style="getStyle()" :content-style="getStyle2()">
                                    <span v-if="dataForm.sourceType=='0'" >招标</span>
                                    <span v-if="dataForm.sourceType=='1'" >议标</span>
                                </el-descriptions-item>

                            </template>
                          <el-descriptions-item label="工厂:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item style="margin-bottom: 0;" prop="werk" size="small">
                              <span>{{dataForm.werk}}</span>
                            </el-form-item>
                          </el-descriptions-item>
                            <el-descriptions-item :span="2" label="定点申请描述" :label-style="getStyle()">
                                <el-form-item style="margin-bottom: 0;" prop="technicalRemark" size="small" >
                                    <span>{{dataForm.technicalRemark}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item :span="2" label="变更说明" :label-style="getStyle()">
                                <el-form-item style="margin-bottom: 0;" size="small" >
                                    <span>{{dataForm.obsoleteDesc}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="接收/反馈人" :label-style="getStyle()">
                                <el-form-item style="margin-bottom: 0;" size="small" >
                                    <span>{{dataForm.updateName}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="接收/反馈时间" :label-style="getStyle()">
                                <el-form-item style="margin-bottom: 0;" prop="updateTime" size="small" >
                                    <span>{{dataForm.updateTime}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item :span="2" label="反馈原因" :label-style="getStyle()">
                                <el-form-item style="margin-bottom: 0;" prop="rejectReason" size="small" >
                                    <span>{{dataForm.rejectReason}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-tab-pane>
                <el-tab-pane class="tab_style" :key="2" label="零件清单">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-table :data="partList" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
                                <el-table-column type="index" width="50" label="行号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <!--<el-table-column prop="deleteFlag" header-align="center" width="70" align="center" label="作废标识">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.deleteFlag=='1'" >已作废</span>
                                        <span v-if="scope.row.deleteFlag=='0'" ></span>
                                    </template>
                                </el-table-column>-->
<!--                                <el-table-column prop="partLine" header-align="center" width="150" align="left" label="行号">-->
<!--                                </el-table-column>-->
                                <el-table-column prop="partCode" header-align="center" width="150" align="left" label="零件编号">
                                </el-table-column>
                                <el-table-column prop="partName" header-align="center" width="160" align="left" label="零件名称">
                                </el-table-column>
                                <el-table-column prop="changeType" header-align="center" width="160" align="left" label="变更类型">
                                  <template slot-scope="scope">
                                    <span>{{ scope.row.changeType === 'D' ? '取消' :
                                        scope.row.changeType === 'C' ? '变更' : '增加' }}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="oneCarCount" width="70" header-align="center" align="center" label="单车用量">
                                </el-table-column>
                                <el-table-column prop="unit" width="70" header-align="center" align="center" label="单位">
                                </el-table-column>
                                <el-table-column prop="supplyStatus" header-align="center" align="center" label="建议货源" width="80">
                                    <template slot-scope="scope">
                                        <span>{{supplyStatusFormat(scope.row.supplyStatus)}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="targetPrice" width="70" header-align="center" align="center" label="目标价格">
                                </el-table-column>
                                <el-table-column prop="targetInvestment" header-align="center" width="90" align="center" label="目标工装费">
                                </el-table-column>
                                <el-table-column prop="targetDevelopment" header-align="center" width="90" align="center" label="目标开发费">
                                </el-table-column>
                                <el-table-column prop="targetTestfee" header-align="center" width="90" align="center" label="目标试验费">
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination class="fr" @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane v-if="this.dataForm.technicalStatus=='1'" class="tab_style" :key="3" label="招标工作计划">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-table :data="biddingList" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
                                <el-table-column type="index" width="50" label="序号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="workContent" header-align="center" align="left" label="工作内容">
                                </el-table-column>
                                <el-table-column prop="chargeDept" header-align="center" align="left" label="责任部门">
                                </el-table-column>
                                <el-table-column prop="workDate" header-align="center" align="right" label="日期" width="170" :formatter="dateFormat">
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination class="fr" @size-change="sizeChangeHandleBidding" @current-change="currentChangeHandleBidding" :current-page="pageIndexBidding" :page-sizes="[10, 20, 50]" :page-size="pageSizeBidding" :total="totalPageBidding" layout="total, sizes, prev, pager, next, jumper">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane v-if="this.dataForm.technicalStatus=='1'" class="tab_style" :key="4" label="推荐供应商">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-table :data="supplierList" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
                                <el-table-column type="index" width="50" label="序号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="recommendedSupplierName" header-align="center" align="left" label="推荐供应商名称">
                                </el-table-column>
                                <el-table-column prop="recommendedSupplierExpierence" header-align="center" align="left" label="项目经验">
                                </el-table-column>

                                <el-table-column prop="committeeContact" header-align="center"  align="left" label="联系人">
                                </el-table-column>
                                <el-table-column prop="contact" header-align="center" align="left" label="联系方式">
                                </el-table-column>
                                <el-table-column prop="remark" header-align="center" align="left" label="备注">
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination class="fr" @size-change="sizeChangeHandleSupplierList" @current-change="
                                    currentChangeHandleSupplierList
                                " :current-page="pageIndexSupplierList" :page-sizes="[10, 20, 50]" :page-size="pageSizeSupplierList" :total="totalPageSupplierList" layout="total, sizes, prev, pager, next, jumper">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane v-if="this.dataForm.technicalStatus=='1'" class="tab_style" :key="5" label="审批历史">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-table :data="approveHistoryList" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
                                <el-table-column type="index" width="50" label="序号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="technicalDepartment" width="160" header-align="center" align="left" label="审批部门">
                                </el-table-column>
                                <el-table-column prop="technicalApprover" width="100" header-align="center" align="left" label="审批人">
                                </el-table-column>

                                <el-table-column prop="technicalSuggstion" header-align="center" align="left" label="审批意见">
                                </el-table-column>
                                <el-table-column prop="technicalTime" width="160" header-align="center" align="left" label="审批时间">
                                </el-table-column>

                            </el-table>
                            <!-- 分页 -->
                            <el-pagination class="fr" @size-change="sizeChangeHandleSupplierList" @current-change="
                                    currentChangeHandleSupplierList
                                " :current-page="pageIndexSupplierList" :page-sizes="[10, 20, 50]" :page-size="pageSizeSupplierList" :total="totalPageSupplierList" layout="total, sizes, prev, pager, next, jumper">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane v-if="this.dataForm.technicalStatus=='1'||this.dataForm.technicalStatus=='3'" class="tab_style" :key="6" label="附件文件">
                    <FileUpDown ref="FileUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE" :canDelete=false :uploadDate=true></FileUpDown>
                </el-tab-pane>
                <el-tab-pane v-if="this.dataForm.technicalStatus=='1' && this.noDownloadFileList.length > 0" class="tab_style" :key="7" label="未下载附件">
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-table :data="noDownloadFileList" row-key="id" size="small" border style="width: 100%" :default-expand-all="false" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
                                <el-table-column type="index" width="50" label="序号">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="url" width="520" header-align="center" align="left" label="URL">
                                </el-table-column>
                                <el-table-column prop="fileName" width="210" header-align="center" align="left" label="文件名称">
                                </el-table-column>
                                <el-table-column header-align="center" align="left" min-width="130" label="操作" width="100">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="downloadHandle(scope.row)">
                                            下载
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination class="fr" @size-change="sizeChangeHandleSupplierList" @current-change="
                                    currentChangeHandleSupplierList
                                " :current-page="pageIndexSupplierList" :page-sizes="[10, 20, 50]" :page-size="pageSizeSupplierList" :total="totalPageSupplierList" layout="total, sizes, prev, pager, next, jumper">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </el-form>
    </div>
</el-dialog>
</template>

<script>
import {
    getPartList,
    getSupplierList,
    getBiddingList,
    getApprovalList,
    getNoDownloadFileList,
    createTechNoti,
    editTechNoti,
    getPlmTechnicalById,
    deletePart,
    deleteSupplier,
    deleteBidding,
    importFile,
    downloadFile
} from "@/controller/plmTech";
import moment from "moment";
import {
    USER_TYPE,
    DIALOG_CLOSED_TYPE,
    SUPPLY_STATUS,
    getLabelByValue,
    TECHNICAL_NOTIFICATION_TYPE,
    TECHNICAL_INFO_STATUS,
    getPLMTechnicalStatusValue,
    getPlmTechnicalTypeValue,
} from "@/utils/const";
import {
    mapping
} from "@/utils";


import FileUpDown from "@/views/common/file-up-down";


import {
    setLoading
} from "@/utils/index";
import { getRealNameById } from '@/controller/sys'
export default {
    components: {

        FileUpDown, //上传附件

    },
    props: {
        //零件列表数据
        partFormData: Object
    },
    data() {
        return {
            FILE_BIZ_TYPE: 20,
            viewFlag: "",
            confirm:'',
            viewData: {
                visible: false,
                width: "",
            },
            TECHNICAL_NOTIFICATION_TYPE: TECHNICAL_NOTIFICATION_TYPE,
            TECHNICAL_INFO_STATUS: TECHNICAL_INFO_STATUS,
            getPLMTechnicalStatusValue: getPLMTechnicalStatusValue,
            getPlmTechnicalTypeValue: getPlmTechnicalTypeValue,
            dataList: [],
            partList: [],
            loading: false,
            // 零件
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            // 供应商
            pageIndexSupplierList: 1,
            pageSizeSupplierList: 10,
            totalPageSupplierList: 0,
            pageIndexBidding: 1,
            pageSizeBidding: 10,
            totalPageBidding: 0,
            supplierList: [],
            biddingList: [],
            biddingPlans: [],
            approveHistoryList: [],
            noDownloadFileList: [],
            projectName: '',
            dataForm: {
                id: 0,
                projectName: "",
                projectManagerName: "",
                technicalType: "",
                carType: "",
                remark: "",
                projectId: "",
                projectCode: "",
                technicalId: "",
                technicalCode: "",
                technicalName: "",
                projectManagerId: "",
                projectType: "",
                sourceType: "",
                committeeContact: "",
                contact: "",
                partCount: "",
                partSumCount: "",
                technicalStatus: "",
                recieveName: "",
                updateTime: "",
                updateName: "",
                werk:"",
            },
            dataRule: {
                technicalType: [{
                    required: true,
                    message: "请选择类型",
                    trigger: "blur",
                }],
                projectManagerName: [{
                    required: true,
                    message: "请选择项目",
                    trigger: "blur",
                }],
                // remark: [{
                //     required: true,
                //     message: "请填写备注",
                //     trigger: "blur",
                // }],
            },
        };
    },
    mounted() {},
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY年MM月DD日");
        },
        // 初始化
        init(rec, viewFlag, confirm) {
            // init(data) {
            // console.log(data)
            // this.dataForm = id ? this.dataForm : this.data;
            // this.dataForm.id =0;
            console.log(this.partList.length)
            this.dataForm.technicalType = ''
            this.viewFlag = viewFlag;
            this.confirm = confirm;
            this.projectName = rec && rec.projectName || ''
            this.dataForm.id = rec && rec.id || null
            this.dataForm.werk = rec.werk || ''
            this.dataForm.technicalStatus = rec.technicalStatus || '1'
            this.partList = []
            this.supplierList = []
            this.biddingList = []
            this.approveHistoryList = []
            this.dataForm.remark = ''
            this.viewData.visible = true
            this.loading = false
            this.$nextTick(() => {
                if(this.$refs.FileUpDown)
                    this.$refs.FileUpDown.init(this.viewFlag);
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id找通知对象
                    getPlmTechnicalById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                    // 调用查询零件 供应商 招标 的List查询方法
                    this.getPartList();
                    this.getSupplierList();
                    this.getBiddingList();
                    this.getApprovalList();
                    this.getNoDownloadFileList();
                }
            });
        },
        // 零件的分页方法
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getPartList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getPartList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        supplyStatusFormat: function (value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(SUPPLY_STATUS, value);
        },
        typeFormat: function (value) {
            // debugger;
            if (!value) {
                return "";
            }
            return getLabelByValue(TECHNICAL_NOTIFICATION_TYPE, value);
        },
        // 查所有零件表
        getPartList() {
            getPartList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                technicalId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.partList = data.body.records;
                    this.totalPage = data.body.total;
                    console.log(this.partList)
                } else {
                    this.partList = [];
                    this.totalPage = 0;
                }
            });
        },
        // 供应商的分页方法
        // 每页数
        sizeChangeHandleSupplierList(val) {
            this.pageSizeSupplierList = val;
            this.pageIndexSupplierList = 1;
            this.getSupplierList();
        },
        // 当前页
        currentChangeHandleSupplierList(val) {
            this.pageIndexSupplierList = val;
            this.getSupplierList();
        },
        // 多选
        selectionChangeHandleSupplierList(val) {
            this.dataListSelections = val;
        },
        // 查所有供应商表
        getSupplierList() {
            getSupplierList({
                pageNo: this.pageIndexSupplierList,
                pageSize: this.pageSizeSupplierList,
                technicalId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.supplierList = data.body.records;
                    this.totalPageSupplierList = data.body.total;
                } else {
                    this.supplierList = [];
                    this.totalPageSupplierList = 0;
                }
            });
        },
        // 招标的分页方法
        // 每页数
        sizeChangeHandleBidding(val) {
            this.pageSizeBidding = val;
            this.pageIndexBidding = 1;
            this.getBiddingList();
        },
        // 当前页
        currentChangeHandleBidding(val) {
            this.pageIndexBidding = val;
            this.getBiddingList();
        },
        // 多选
        selectionChangeHandleBidding(val) {
            this.dataListSelections = val;
        },
        // 查所有招标表
        getBiddingList() {
            getBiddingList({
                pageNo: this.pageIndexBidding,
                pageSize: this.pageSizeBidding,
                technicalId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.biddingList = data.body.records;
                    this.totalPageBidding = data.body.total;
                } else {
                    this.biddingList = [];
                    this.totalPageBidding = 0;
                }
            });
        },
        // 查所有审批历史
        getApprovalList() {
            getApprovalList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                technicalId: this.dataForm.id,
            }).then((data) => {
               if (data && data.code === "00") {
                  this.approveHistoryList = data.body.records;
                  this.totalPage = data.body.total;
                  console.log(this.approveHistoryList)
               } else {
                  this.approveHistoryList = [];
                  this.totalPage = 0;
               }
            });
        },
        // 查未下载的附件
        getNoDownloadFileList() {
            getNoDownloadFileList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                technicalId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.noDownloadFileList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.noDownloadFileList = [];
                    this.totalPage = 0;
                }
            });
        },
        downloadHandle(row) {
            debugger
            console.log(row, 'row')
            this.loading = true
            downloadFile({
                'id': row.id
            }).then(data => {
                if (data && data.code === '00' && data.body) {
                    this.$message({
                        message: "文件接收成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.loading = false
                            this.$emit("refreshDataList")
                        },
                    });
                } else {
                     this.loading = false
                     this.$message({
                         message: data.msg,
                         type: 'warning'
                     })
                }
            })
        },
        getStyle() {
            return 'width: 130px; text-align: right'
        },
        getStyle2() {
            return 'width: 425.5px;'
        },
    },
};
</script>

<style lang="scss" scoped>
.tab_style {
    min-height: 40vh;
}
</style>
